import { FunctionComponent } from 'react';
import styles from "./ReengagementForm.module.css";
import cn from 'classnames';
import {Card} from 'react-bootstrap';
import FormField, { IFieldTheme, IFieldType } from '../../common/FormField/FormField';
import FormTextArea from '../../common/FormField/FormTextArea';
import FormCheckbox from '../../common/FormField/FormCheckbox';
import CustomButton, { ButtonType } from '../../common/CustomButton/CustomButton';

interface IReengagementFormProps {
    className?: string;
};

const ReengagementForm: FunctionComponent<IReengagementFormProps> = ({className }) => {

    return (
        <Card className={cn(styles.addNewCampaignForm, className)}>
            <div className={cn(styles.formArea)}>
                <div className={styles.formDetail}>
                    <div className={styles.formDetailRowOne}>
                        <div className={styles.title}>New Campaign</div>
                        <div className={styles.formFieldWrap}>
                            <div className={styles.inputText}>
                                <FormField
                                    label='Mail title'
                                    fieldType={IFieldType.TEXT} 
                                    fieldTheme={IFieldTheme.LIGHT}
                                    placeholder='Enter mail Title'
                                />
                            </div>
                            <div className={styles.inputDateWrap}>
                                <FormField
                                    label='Start Date'
                                    fieldType={IFieldType.DATE} 
                                    fieldTheme={IFieldTheme.LIGHT}
                                    className={styles.date}
                                    placeholder='Select start date'
                                />
                                <FormField
                                    label='End Date (Optional)'
                                    fieldType={IFieldType.DATE} 
                                    fieldTheme={IFieldTheme.LIGHT}
                                    className={styles.date}
                                    placeholder='Select end date'
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.checkboxesWrap}>
                    <Card.Title as={'div'} bsPrefix={styles.subtitle}>Notification Channels</Card.Title>
                    <div className={styles.checkboxes}>
                        <FormCheckbox label={'In App'} />
                        <FormCheckbox label={'Email'} />
                        <FormCheckbox label={'SMS'} />
                    </div>
                </div>
                <div className={styles.formDetailRowThree}>
                    <FormTextArea
                        label='Preview Message'
                        fieldTheme={IFieldTheme.LIGHT}
                        placeholder={`Hi [User Name],
Ready to level up your experience? Fishinity Pro is packed with advanced features—enhanced tracking, smart notifications, and real-time analytics—to help you fish smarter and faster. Upgrade now and make every catch count.`}
                    />
                </div>
            </div>
            <div className={cn(styles.formOption)}>
                <CustomButton 
                    className={styles.addNewContentBtn}
                    btnType={ButtonType.LIGHT}
                >
                    Cancel
                </CustomButton>
                <CustomButton 
                    className={styles.addNewContentBtn}
                    btnType={ButtonType.GREEN}
                >
                    Upload & Publish
                </CustomButton>
            </div>
        </Card>
    );
};

export default ReengagementForm;
